import { authRefreshUrl, buildRefreshBody, USE_OFFLINE_API_MOCK } from './contract'
import { mockFetchResponse, isMockableUrl } from './mock-api'
import {
  getLocalSession,
  saveRefreshToken,
  updateTokensInLocalStorage
} from './session-store'

const REFRESH_UNAVAILABLE_FLAG = 'adams_refresh_unavailable'

function isRefreshTemporarilyUnavailable() {
  try {
    return localStorage.getItem(REFRESH_UNAVAILABLE_FLAG) === '1'
  } catch {
    return false
  }
}

function markRefreshUnavailable() {
  try {
    localStorage.setItem(REFRESH_UNAVAILABLE_FLAG, '1')
  } catch {
    /* ignore */
  }
}

/**
 * @returns {Promise<string | null>} New access token or null
 */
export async function tryRefreshAccessToken() {
  if (isRefreshTemporarilyUnavailable()) return null
  const session = await getLocalSession()
  if (!session?.refreshToken) return null

  const url = authRefreshUrl()
  try {
    let res
    if (USE_OFFLINE_API_MOCK && isMockableUrl(url)) {
      res = await mockFetchResponse(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildRefreshBody(session.refreshToken))
      })
    } else {
      res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(buildRefreshBody(session.refreshToken))
      })
    }

    if (!res.ok) {
      if ([404, 405, 501].includes(res.status)) {
        markRefreshUnavailable()
      }
      return null
    }
    const data = await res.json()
    const inner = data.responseData !== undefined ? data.responseData : data
    const token = inner?.token || data.token
    const refreshToken = inner?.refreshToken || data.refreshToken
    if (!token || typeof token !== 'string') return null
    updateTokensInLocalStorage(token, refreshToken)
    if (refreshToken) await saveRefreshToken(refreshToken)
    return token
  } catch {
    return null
  }
}
